import { yupResolver } from '@hookform/resolvers/yup'
import { AxiosError } from 'axios'
import UserForm from 'components/userManagement/userForm'
import { formatObjectWithPageAccess } from 'components/userManagement/utils'
import { Helmet } from 'react-helmet'
import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'
import { createUser } from 'utils/api/userManagement'
import { ERROR_CODES, PAGE_USER_MGMT } from 'utils/constants'
import { addUserSchema, AddUserType } from 'utils/schema/authSchema'

const AddUser = () => {
  const navigate = useNavigate()

  const form = useForm<AddUserType>({
    resolver: yupResolver(addUserSchema),
  })

  const handleCreateUser = async (userData: Record<string, unknown>) => {
    const formData = formatObjectWithPageAccess(userData)

    const loader = toast.loading('Addding User...')
    try {
      await createUser(formData)
      toast.success('User created successfully', { id: loader })
      navigate(PAGE_USER_MGMT.path)
    } catch (error) {
      if (error instanceof AxiosError) {
        const msg = error?.response?.data?.errors?.msg

        if (msg === ERROR_CODES.EMAIL_ALREADY_EXISTS) {
          return toast.error('Email already exist!', { id: loader })
        }
      }
      toast.error('Some Error Occured!', { id: loader })
    }
  }

  return (
    <>
      <Helmet>
        <title>ORMS Create User </title>
      </Helmet>

      <UserForm
        submitButtonText="Submit"
        submitHandler={handleCreateUser}
        hookForm={form}
      />
    </>
  )
}

export default AddUser
